import React from 'react';

const User = (props) => {
  return(
    <div className="snake-user-input">
      <h2 style={{color: 'white', textAlign: 'center', marginBottom: '20px', textShadow: '2px 2px 4px rgba(0,0,0,0.5)'}}>
        🐍 Snake Game
      </h2>
      <select onChange={props.changeLevel} className="snake-change-level">
        <option value="Easy">🟢 Easy</option>
        <option value="Medium">🟡 Medium</option>
        <option value="Expert">🔴 Expert</option>
      </select>
      <input 
        type="text" 
        placeholder="Enter Your Name (2+ chars)" 
        className="snake-user-name" 
        maxLength="15" 
        minLength="2"
        required
        onChange={props.handleChange} 
      />
      <button 
        className="snake-start-button" 
        onClick={props.handleSubmit}
      >
        🚀 START GAME
      </button>
    </div>
  );
}

export default User;